<template>
  <div style="display: inline-block;">
    <AddProducts :product="good" :fromGood="true" v-on:add="submit" :isSingle='false'>
      <slot></slot>
    </AddProducts>
  </div>
</template>

<script>
import AddProducts from '../publish_task/components/AddProducts'
import api from '../../services/api.js'

export default {
  name: 'goodAdd',
  props: ['product','business'],
  components: {
    AddProducts: AddProducts
  },
  computed: {
    taskInfo () {
	    return this.$store.state.taskInfo
    }
  },
  data () {
    return {
        good: {
            good_id: '',
            name: '',
            website: '',
            spec: '',
            price: '',
            picture:'',
            discounted_price: '',
            number: 1,
            currency: null,
            currency_symbol: null
        },   
    }
  },
  created() {
      this.init()
  },
  methods: {
    init () {
        
        this.good.business_id = this.business.id || this.product.business_id
        this.good.business_name = this.business.name
        this.good.business_website = this.business.website
        this.good.good_id = this.product.id
        this.good.name = this.product.name
        this.good.website = this.product.url
        this.good.spec = this.product.spec
        this.good.price = this.product.price
        this.good.picture = this.product.picture_url
        let time = new Date().getTime()
        if(time > new Date(this.product.coupon_start).getTime() && time < new Date(this.product.coupon_end).getTime()){
            this.good.discounted_price = this.product.discounted_price
        }else{
            this.good.discounted_price = this.product.price
        }
        this.good.currency = this.product.currency
        this.good.currency_symbol = this.product.currency_symbol
    },
    async submit (data) {
      console.log('form',data.form)
      let flag = false
      if(data.isSingle){
        
        if (!data.form.price) {
          data.form.price = data.form.discounted_price
        }
        if (!data.form.discounted_price) {
          data.form.discounted_price = data.form.price
        }
        data.form.id = +new Date()
        this.taskInfo.business_id = data.form.business_id
        this.taskInfo.business_name = data.form.business_name
        this.taskInfo.business_website = data.form.business_website
        this.taskInfo.goods_list = this.taskInfo.goods_list || []
        if(this.taskInfo.goods_list.length > 0) {
          _.each(this.taskInfo.goods_list,item => {
            if(item.business_website == data.form.business_website && item.name == data.form.name && item.spec == data.form.spec && item.price == data.form.price && item.discounted_price == data.form.discounted_price && item.picture == data.form.picture && item.website == data.form.website){
              item.number = Number(item.number) + 1
              flag = true
              this.$store.commit('updateTaskInfo', this.taskInfo)
              this.$emit('success')
            }
          })
        }
        if(flag){
          return
        }
        this.taskInfo.goods_list.push(data.form)
        this.taskInfo.business = data.form.business
        this.$store.commit('updateTaskInfo', this.taskInfo)
        this.$emit('success')
      }else{
        let cartList = await api.getCartList(this)
        if(cartList.body.result) {
          let list = cartList.body.result
          _.each(list,async item => {
            if(item.status == '0'&& item.business_name == data.form.business_name && item.business_website == data.form.business_website && item.name == data.form.name && item.spec == data.form.spec && item.price == data.form.price && item.discounted_price == data.form.discounted_price && item.picture == data.form.picture && item.website == data.form.website) {
                item.currency = data.form.currency
                item.currency_symbol = data.form.currency_symbol
                item.number = Number(item.number) + 1
                flag = true
                let res = await api.post(this, {
                  path: 'cart.php',
                  api: 'update',
                  data: [item],
                  loading: 'loading'
                })
                if (res.body.status == 'ok') {
                  if (this.product) {
                    this.good = Object.assign(this.good, data.form)
                  }
                  this.$emit('success')
                }
            }
          })
          if(flag) {
            return
          }
          let res = await api.post(this, {
              path: 'cart.php',
              api: 'add',
              data: [data.form],
              loading: 'loading'
            })
          if (res.body.status == 'ok') {
            if (this.product) {
              this.good = Object.assign(this.good, data.form)
            }
            this.$emit('success')
          }
        }else{
            let res = await api.post(this, {
                path: 'cart.php',
                api: 'add',
                data: [data.form],
                loading: 'loading'
              })
            if (res.body.status == 'ok') {
              if (this.product) {
                this.good = Object.assign(this.good, data.form)
              }
              this.$emit('success')
            }
        }
      }
      
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/merchant/AddProducts.vue